import React from 'react';
// import {Glyphicon} from 'react-bootstrap';


// 置於最內部，接收click事件最優先
// 上層元件的position要設為relative
// 傳入onDelete func

const RemoveIcon = props => (
  <span
    className='component glyphicon glyphicon-remove-sign'
    onClick={props.onFileDelete}></span>
);

export default RemoveIcon;


// WEBPACK FOOTER //
// ./src/commonComponents/RemoveIcon.jsx